import { render, staticRenderFns } from "./userstatistic1.vue?vue&type=template&id=22cee5a2&scoped=true&"
import script from "./userstatistic1.vue?vue&type=script&lang=js&"
export * from "./userstatistic1.vue?vue&type=script&lang=js&"
import style0 from "./userstatistic1.vue?vue&type=style&index=0&id=22cee5a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cee5a2",
  null
  
)

export default component.exports